import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { Effects, FadeMethod, MoveMethod } from "../../types";
import { DEFAULT_ANIMATION_DURATION_SECONDS } from "../../constants";
import { getMotionEasing } from "./easingMap";
import { BASE_PREVIEW_DELAY } from "./constants";

interface AnimState {
  opacity: number;
  instant: boolean;
}

interface FadeInFadeOutWrapperProps {
  children: React.ReactNode;
  effect: Effects.fadeIn | Effects.fadeOut;
  duration?: number;
  delay?: number;
  method?: MoveMethod | FadeMethod;
}

export const FadeInFadeOutWrapper: React.FC<FadeInFadeOutWrapperProps> = ({
  children,
  effect,
  duration = DEFAULT_ANIMATION_DURATION_SECONDS,
  delay = 0,
  method,
}) => {
  const [animState, setAnimState] = useState<AnimState>({
    opacity: effect === Effects.fadeOut ? 1 : 0,
    instant: false,
  });

  useEffect(() => {
    const delayMs = delay * 1000;
    const durationMs = duration * 1000;

    if (effect === Effects.fadeOut) {
      const hideTimer = setTimeout(
        () => {
          setAnimState({ opacity: 0, instant: false });
        },
        BASE_PREVIEW_DELAY * 1000 + delayMs
      );
      const showTimer = setTimeout(
        () => {
          setAnimState({ opacity: 1, instant: true });
        },
        BASE_PREVIEW_DELAY * 1000 + delayMs + durationMs + 500
      );
      return () => {
        clearTimeout(hideTimer);
        clearTimeout(showTimer);
      };
    } else {
      const showTimer = setTimeout(
        () => {
          setAnimState({ opacity: 1, instant: false });
        },
        BASE_PREVIEW_DELAY * 1000 + delayMs
      );
      return () => {
        clearTimeout(showTimer);
      };
    }
  }, [effect, duration, delay]);

  return (
    <motion.div
      initial={{ opacity: effect === Effects.fadeOut ? 1 : 0 }}
      animate={{ opacity: animState.opacity }}
      transition={{
        duration: animState.instant ? 0 : duration,
        ease: animState.instant ? undefined : getMotionEasing(method),
      }}
      style={{ width: "100%", height: "100%" }}
    >
      {children}
    </motion.div>
  );
};
